import { IEmploymentInfo, OccupationalStatus } from '@shared/integrations/taf-api/v2/models';

export interface ICompanyV2Model {
    accountId?: string;
    clubId?: string;
    clubName?: string;
    name?: string;
    organizationId?: string;
}

export interface IEmployments {
    id: string;
    name: string;
}

export interface IOccupationalStatusProps {
    occupationStatus: OccupationalStatus;
}

export interface IEmploymentProps {
    employment: IEmploymentInfo;
}

export enum EmploymentUpdateStatus {
    Success = 'success',
    Error = 'error'
}
